import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DataTablesMenu from '../components/data-tables/DataTablesMenu.vue';
import DataTablesList from '../components/data-tables/DataTablesList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'DataTablesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DataTablesMenu),
    _createVNode(DataTablesList)
  ], 64))
}
}

})